/**
 *
 * Asynchronously loads the component for ModalConfirm
 * Author: LanVt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
